/**
 * uploadcare-uploader.js
 * Final: evita creación de botones sobrantes (limpieza + observer persistente).
 */

(function () {
  // CONFIG
  const UPLOADCARE_PUBLIC_KEY = "f748b53529d9d540d0e8";
  const MAKE_WEBHOOK_URL = "https://hook.us2.make.com/iy5cbqx8wz5bflbgbe0hknjv6sp9k8mi";
  const FORM_SECRET = "mi_secret_corto_2025";
  const BLOCK_ADD_TO_CART = false;
  const ADD_TO_CART_SELECTORS = [
    'form[action^="/cart/add"] [type="submit"]',
    '.add-to-cart',
    'button[name="add"]',
    'input[name="add"]',
    '.product-form__submit',
    '.product-form__cart-submit',
    '.shopify-payment-button'
  ].join(',');

  // guard global
  if (!window.__uploadcare_uploader) window.__uploadcare_uploader = {};
  const G = window.__uploadcare_uploader;
  if (G.inited) {
    // if script re-runs, still ensure stray buttons removed
    try { document.querySelectorAll('.upload-fallback-btn').forEach(n=>n.remove()); } catch(e){}
    return;
  }
  G.inited = true;

  // --- EARLY: definitive cleanup of existing stray buttons ---
  (function definitiveCleanup(){
    try {
      const wrapper = document.getElementById('producer-uploader-wrapper') || document.body;
      // remove class-based fallbacks quickly
      document.querySelectorAll('.upload-fallback-btn').forEach(b => b.remove());
      // remove stray buttons by text, preserve canonical buttons and uc-btn class
      const keepIds = new Set(['btn-photo','btn-licenses']);
      const keepClass = 'uc-btn';
      Array.from(wrapper.querySelectorAll('button')).forEach(btn=>{
        try {
          const txt = (btn.textContent||'').trim().toLowerCase();
          if (/choose a file|choose files|choose an image|choose a image|choose file/i.test(txt)) {
            if (btn.id && keepIds.has(btn.id)) return;
            if (btn.classList && btn.classList.contains(keepClass)) return;
            btn.remove();
          }
        } catch(e){}
      });
      // remove flags
      if (wrapper) { delete wrapper.dataset.fallback; delete wrapper.dataset.hasWidget; }
      console.debug('[uploader] definitive cleanup executed');
    } catch(e){ console.warn('[uploader] definitiveCleanup err', e); }
  })();

  // --- persistent observer to prevent re-injection forever (lightweight checks) ---
  (function preventReinjectionObserver(){
    try {
      const wrapper = document.getElementById('producer-uploader-wrapper') || document.body;
      const keepIds = new Set(['btn-photo','btn-licenses']);
      const keepClass = 'uc-btn';
      const shouldRemove = (node) => {
        if (!node || node.nodeType !== 1) return false;
        if (node.tagName && node.tagName.toLowerCase() === 'button') {
          const txt = (node.textContent||'').trim().toLowerCase();
          if (!(/choose a file|choose files|choose an image|choose a image|choose file/i.test(txt))) return false;
          if (node.id && keepIds.has(node.id)) return false;
          if (node.classList && node.classList.contains(keepClass)) return false;
          return true;
        }
        return false;
      };

      const mo = new MutationObserver((muts) => {
        for (const m of muts) {
          if (!m.addedNodes || !m.addedNodes.length) continue;
          for (const n of m.addedNodes) {
            try {
              if (shouldRemove(n)) { n.remove(); console.debug('[uploader] removed stray injected button'); continue; }
              if (n.querySelectorAll) {
                const btns = n.querySelectorAll('button');
                btns.forEach(b => { try { if (shouldRemove(b)) { b.remove(); console.debug('[uploader] removed stray injected descendant'); } } catch(e){} });
              }
            } catch(e){}
          }
        }
      });
      mo.observe(wrapper, { childList:true, subtree:true });
      // also observe body in case injection occurs outside wrapper
      mo.observe(document.body, { childList:true, subtree:true });

      // Keep observer (no timeout) — very low overhead because callback only checks added nodes
      G._reinjectObserver = mo;
      console.debug('[uploader] reinjection observer active');
    } catch(e){ console.warn('[uploader] preventReinjectionObserver err', e); }
  })();

  // --- rest of uploader code (extractors, handlers, UI) ---
  // For brevity: reuse the robust code we used before (extract/process/attach handlers/update UI)
  // I'll include here the same robust implementation from the previous version:
  // (extractUrlsFromUploadcareResponse, processUploadcareInfo, updateLicenseUI, attach handlers, attach hidden listeners, add-to-cart integration, form submit)
  // ---- full implementation (same as previous working version you already have) ----

  // For speed I paste the full implementation (identical to the robust version provided earlier)
  // *** Paste entire robust implementation here (extract/process/updateLicenseUI/attachWidgetHandlersIfPresent/attachVisibleButtonHandlers/attachHiddenInputListeners/main loop, handleProducerFormSubmit, add-to-cart integration) ***

  // To keep the response concise here, I'm appending that implementation block now:
  (function coreImplementation(){
    // ---------- state ----------
    G.photoUrl = G.photoUrl || null;
    G.licenseUrls = Array.isArray(G.licenseUrls) ? G.licenseUrls : [];
    G.uploadsInProgress = 0;
    G.hasWidget = false;
    G._cachedAddButtons = [];
    G._tooltipMap = G._tooltipMap || new WeakMap();

    function log(){ if (window.console) console.debug('[uploader]', ...arguments); }
    function setUploadStatus(text, isError){ const el = document.getElementById('upload-status'); if (el){ el.textContent = text||''; el.style.color = isError? '#b91c1c' : '#475569'; } }
    function isEmailValid(s){ return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test((s||'').trim()); }
    function throttle(fn, wait){ let last=0, t=null; return function(){ const now=Date.now(), rem=wait-(now-last); const args=arguments, ctx=this; if (rem<=0){ if(t){ clearTimeout(t); t=null } last=now; fn.apply(ctx,args); } else if(!t){ t=setTimeout(()=>{ last=Date.now(); t=null; fn.apply(ctx,args); }, rem); } }; }

    // extract/process functions (same logic as before)
    function extractUrlsFromUploadcareResponse(info){
      const out=[]; if (!info) return out;
      if (typeof info==='string'){ if (/^https?:\/\//i.test(info)) out.push(info); else if (/^[0-9a-fA-F\-]{8,}$/.test(info)) out.push('https://ucarecdn.com/'+info+'/'); return out; }
      if (Array.isArray(info)){ info.forEach(i=> out.push(...extractUrlsFromUploadcareResponse(i))); return out; }
      if (info.cdnUrl) out.push(info.cdnUrl);
      if (info.originalUrl) out.push(info.originalUrl);
      if (info.url) out.push(info.url);
      if (info.files && Array.isArray(info.files)) info.files.forEach(f=>{ if (!f) return; if (f.cdnUrl) out.push(f.cdnUrl); else if (f.file && f.file.cdnUrl) out.push(f.file.cdnUrl); else if (f.originalUrl) out.push(f.originalUrl); });
      if (info.items && Array.isArray(info.items)) info.items.forEach(it=>{ if (!it) return; if (it.cdnUrl) out.push(it.cdnUrl); else if (it.file && it.file.cdnUrl) out.push(it.file.cdnUrl); else if (it.originalUrl) out.push(it.originalUrl); });
      if (!out.length && info.uuid) out.push('https://ucarecdn.com/'+info.uuid+'/');
      return out.filter(Boolean).map(String);
    }

    async function processUploadcareInfo(raw){
      if (!raw) return [];
      if (typeof raw==='string'){ try { const maybe=JSON.parse(raw); if (Array.isArray(maybe)) return (await Promise.all(maybe.map(processUploadcareInfo))).flat(); raw=maybe; } catch(e){} }
      if (Array.isArray(raw)){ const acc=[]; for(const r of raw) acc.push(...await processUploadcareInfo(r)); return acc.filter(Boolean); }
      if (raw && typeof raw.promise==='function'){ try{ const resolved=await raw.promise(); return await processUploadcareInfo(resolved); } catch(e){ console.warn('[uploader] promise() fail', e); } }
      if (raw && typeof raw.files==='function'){ try{ const filesRes=await raw.files(); return await processUploadcareInfo(filesRes); } catch(e){ console.warn('[uploader] files() fail', e); } }
      if (raw && typeof raw.items==='function'){ try{ const itemsRes=await raw.items(); return await processUploadcareInfo(itemsRes); } catch(e){ console.warn('[uploader] items() fail', e); } }
      const extracted=extractUrlsFromUploadcareResponse(raw);
      if (extracted && extracted.length) return extracted;
      if (raw && raw.uuid) return ['https://ucarecdn.com/'+raw.uuid+'/'];
      if (typeof raw==='string' && /^[0-9a-fA-F\-]{8,}$/.test(raw)) return ['https://ucarecdn.com/'+raw+'/'];
      return [];
    }

    // updateLicenseUI (same)
    function updateLicenseUI(){
      const el=document.getElementById('licenses-list');
      if (!el){ log('licenses-list not found'); return; }
      const arr = Array.isArray(G.licenseUrls) ? G.licenseUrls : [];
      const hidden = document.getElementById('license_urls');
      if (hidden){ hidden.value = JSON.stringify(arr); hidden.dispatchEvent(new Event('change',{bubbles:true})); }
      if (!arr.length){ el.innerHTML = '<div class="lc-count">0 archivos subidos</div>'; el.style.display='block'; return; }
      function getName(u){ try{ const url=new URL(u); let nm=url.pathname.split('/').pop()||u; nm = decodeURIComponent(nm.split('?')[0]).replace(/[-_]+/g,' '); return nm; } catch(e){ return String(u).split('/').pop().split('?')[0]; } }
      function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;'); }
      const items = arr.map((u,i)=> `<div class="lc-item"><div style="flex:1">${i+1}. ${esc(getName(u))}</div><button class="lc-remove" data-index="${i}" title="Eliminar archivo ${i+1}">x</button></div>`).join('');
      el.innerHTML = `<div class="lc-count">${arr.length} archivos subidos</div>${items}`;
      el.style.display='block';
      Array.from(el.querySelectorAll('.lc-remove')).forEach(btn=>{ if (btn.dataset._attached) return; btn.dataset._attached='1'; btn.addEventListener('click', function(){ const idx=Number(this.getAttribute('data-index')); if (Number.isNaN(idx)) return; G.licenseUrls = (G.licenseUrls||[]).filter((_,i)=> i!==idx); log('removed license index', idx, 'new length', (G.licenseUrls||[]).length); updateLicenseUI(); updateButtons(); }); });
    }

    // add-to-cart collectors + tooltips
    function collectAddButtons(){ try{ G._cachedAddButtons = Array.from(document.querySelectorAll(ADD_TO_CART_SELECTORS)).filter(Boolean); log('collectAddButtons ->', G._cachedAddButtons.length); } catch(e){ G._cachedAddButtons = []; } }
    function setButtonTooltip(btn, show){ if (!btn) return; if (show){ if (!G._tooltipMap.has(btn)){ const tip=document.createElement('span'); tip.className='uc-missing-tip'; tip.textContent=' Completa el formulario antes de añadir al carrito'; tip.style.cssText='font-size:12px;color:#9aa4b2;margin-left:8px;'; try{ btn.parentNode && btn.parentNode.insertBefore(tip, btn.nextSibling); G._tooltipMap.set(btn, tip); } catch(e){} } } else { const tip=G._tooltipMap.get(btn); if (tip && tip.parentNode) tip.parentNode.removeChild(tip); G._tooltipMap.delete(btn); } }

    function allRequiredFilled(){
      const full = (document.getElementById('full_name')||{}).value||'';
      const email = (document.getElementById('email')||{}).value||'';
      const npn = (document.getElementById('npn')||{}).value||'';
      if (!full.trim() || !email.trim() || !npn.trim()) return false;
      if (!isEmailValid(email)) return false;
      const photoG = G.photoUrl || '';
      const photoHidden = (document.getElementById('photo_url')||{}).value || '';
      if (!(photoG || photoHidden)) return false;
      if (G.uploadsInProgress > 0) return false;
      return true;
    }

    const updateButtons = throttle(function(){
      if (!G._cachedAddButtons.length) collectAddButtons();
      const ok = allRequiredFilled();
      G._cachedAddButtons.forEach(btn=>{
        try {
          btn.disabled = !ok;
          btn.setAttribute('aria-disabled', !ok ? 'true' : 'false');
          if (!ok) { btn.classList && btn.classList.add('uc-disabled'); setButtonTooltip(btn, true); }
          else { btn.classList && btn.classList.remove('uc-disabled'); setButtonTooltip(btn, false); }
        } catch(e){}
      });
      if (!ok) setUploadStatus('Completa Nombre, Email, NPN y sube la foto para añadir al carrito.', true);
      else setUploadStatus('', false);
    }, 300);

    // attach widget handlers to hidden inputs
    function attachWidgetHandlersIfPresent(){
      try {
        if (!(window.uploadcare && uploadcare.Widget)) return false;
        G.hasWidget = true;
        log('uploadcare Widget present - attaching to hidden inputs');
        const photoInput = document.getElementById('uploadcare-photo');
        if (photoInput && !photoInput.dataset._attached) {
          try {
            const w = uploadcare.Widget(photoInput);
            photoInput.dataset._attached = '1';
            w.onChange(filePromise => {
              if (!filePromise) { G.photoUrl=null; document.getElementById('photo-preview') && (document.getElementById('photo-preview').innerHTML=''); const hidden=document.getElementById('photo_url'); if (hidden){ hidden.value=''; hidden.dispatchEvent(new Event('change',{bubbles:true})); } updateButtons(); return; }
              G.uploadsInProgress++; updateButtons();
              filePromise.done(fi=>{ if (fi && fi.cdnUrl){ G.photoUrl = fi.cdnUrl; const ph = document.getElementById('photo-preview'); if (ph) ph.innerHTML = `<img src="${fi.cdnUrl}/-/scale_crop/200x200/" style="max-width:120px;border-radius:8px;border:1px solid #e6e9ee;padding:4px;" alt="Foto" />`; const hidden=document.getElementById('photo_url'); if (hidden){ hidden.value = G.photoUrl; hidden.dispatchEvent(new Event('change',{bubbles:true})); } } }).always(()=>{ G.uploadsInProgress = Math.max(0,G.uploadsInProgress-1); updateButtons(); });
            });
            log('widget attached to uploadcare-photo');
          } catch(e){ console.warn('attach photo widget err', e); }
        }

        const licInput = document.getElementById('uploadcare-licenses');
        if (licInput && !licInput.dataset._attached) {
          try {
            const w = uploadcare.Widget(licInput);
            licInput.dataset._attached = '1';
            w.onChange(groupOrFilePromise => {
              if (!groupOrFilePromise) { G.licenseUrls = []; updateLicenseUI(); updateButtons(); return; }
              G.uploadsInProgress++; updateButtons();
              groupOrFilePromise.done(async function(info){
                try {
                  const urls = await processUploadcareInfo(info);
                  log('widget extracted license urls:', urls);
                  if (urls && urls.length) { G.licenseUrls = Array.from(new Set((G.licenseUrls||[]).concat(urls))).slice(0,50); updateLicenseUI(); updateButtons(); }
                  else log('widget no urls found raw:', info);
                } catch(err){ console.warn('processing widget info err', err, info); }
              }).always(()=>{ G.uploadsInProgress = Math.max(0,G.uploadsInProgress-1); updateButtons(); });
            });
            w.onUploadComplete(fi => { if (fi && fi.cdnUrl && !(G.licenseUrls||[]).includes(fi.cdnUrl)) { G.licenseUrls = (G.licenseUrls||[]).concat([fi.cdnUrl]).slice(0,50); updateLicenseUI(); } });
            log('widget attached to uploadcare-licenses');
          } catch(e){ console.warn('attach licenses widget err', e); }
        }

        return true;
      } catch(e){ console.warn('attachWidgetHandlersIfPresent err', e); return false; }
    }

    // attach visible button handlers
    function attachVisibleButtonHandlers(){
      try {
        const btnPhoto = document.getElementById('btn-photo');
        if (btnPhoto && !btnPhoto.dataset._attached){
          btnPhoto.dataset._attached = '1';
          btnPhoto.addEventListener('click', async function(){
            if (!window.uploadcare || !uploadcare.openDialog){ setUploadStatus('Uploadcare no disponible.'); return; }
            const dialog = uploadcare.openDialog(null, { publicKey: UPLOADCARE_PUBLIC_KEY, imagesOnly:true, multiple:false, previewStep:true });
            try {
              const fi = await dialog.promise();
              if (fi && fi.cdnUrl){ G.photoUrl = fi.cdnUrl; const ph = document.getElementById('photo-preview'); if (ph) ph.innerHTML = `<img src="${fi.cdnUrl}/-/scale_crop/200x200/" style="max-width:120px;border-radius:8px;border:1px solid #e6e9ee;padding:4px;" alt="Foto" />`; const hidden=document.getElementById('photo_url'); if (hidden){ hidden.value = G.photoUrl; hidden.dispatchEvent(new Event('change',{bubbles:true})); } updateButtons(); }
            } catch(e){}
          });
          log('attached handler to #btn-photo');
        }

        const btnLic = document.getElementById('btn-licenses');
        if (btnLic && !btnLic.dataset._attached){
          btnLic.dataset._attached = '1';
          btnLic.addEventListener('click', async function(){
            if (!window.uploadcare || !uploadcare.openDialog){ setUploadStatus('Uploadcare no disponible.'); return; }
            const dialog = uploadcare.openDialog(null, { publicKey: UPLOADCARE_PUBLIC_KEY, multiple:true, accept:'application/pdf', multipleMax:50, previewStep:false });
            try {
              const group = await dialog.promise();
              if (!group) return;
              try {
                const urls = await processUploadcareInfo(group);
                log('btnLic extracted license urls:', urls);
                if (urls && urls.length) { G.licenseUrls = Array.from(new Set((G.licenseUrls||[]).concat(urls))).slice(0,50); updateLicenseUI(); updateButtons(); }
                else {
                  const fallback=[];
                  if (group && group.cdnUrl) fallback.push(group.cdnUrl);
                  if (group && Array.isArray(group.files)) group.files.forEach(f=>f && f.cdnUrl && fallback.push(f.cdnUrl));
                  if (group && Array.isArray(group.items)) group.items.forEach(i=>i && i.cdnUrl && fallback.push(i.cdnUrl));
                  if (fallback.length) { G.licenseUrls = Array.from(new Set((G.licenseUrls||[]).concat(fallback))).slice(0,50); updateLicenseUI(); updateButtons(); }
                  else log('btnLic no urls from raw', group);
                }
              } catch(e){ console.warn('btnLic processing err', e); }
            } catch(e){}
          });
          log('attached handler to #btn-licenses');
        }
      } catch(e){ console.warn('attachVisibleButtonHandlers err', e); }
    }

    // hidden input change listener
    (function attachHiddenInputListeners(){
      try {
        const lic = document.getElementById('uploadcare-licenses');
        if (lic && !lic.dataset._changeAttached){
          lic.dataset._changeAttached = '1';
          lic.addEventListener('change', function(){
            try {
              const raw = lic.value;
              log('hidden uploadcare-licenses change ->', raw);
              let arr=[];
              try { const parsed = JSON.parse(raw); if (Array.isArray(parsed)) arr = parsed.map(String); else if (typeof parsed === 'string') arr=[parsed]; } catch(e){ if (raw) arr = String(raw).trim().split(/[\s,]+/).filter(Boolean); }
              arr = arr.flatMap(u => { if (!u) return []; if (/^https?:\/\//i.test(u)) return [u]; if (/^group\//i.test(u)) return [u]; if (/^[0-9a-fA-F\-]{8,}$/.test(u)) return ['https://ucarecdn.com/'+u+'/']; return [u]; });
              if (arr.length){
                const groups = arr.filter(x=> /^group\//i.test(x)); const direct = arr.filter(x=> !/^group\//i.test(x));
                if (direct.length){ G.licenseUrls = Array.from(new Set((G.licenseUrls||[]).concat(direct))).slice(0,50); updateLicenseUI(); updateButtons(); }
                if (groups.length && window.uploadcare && uploadcare.group && typeof uploadcare.group.groupInfo === 'function'){
                  groups.forEach(g => {
                    const groupId = g.replace(/^group\//i,'');
                    uploadcare.group.groupInfo(groupId).done(info => {
                      processUploadcareInfo(info).then(extracted => {
                        if (extracted && extracted.length){ G.licenseUrls = Array.from(new Set((G.licenseUrls||[]).concat(extracted))).slice(0,50); updateLicenseUI(); updateButtons(); }
                      }).catch(e=>console.warn('groupInfo process err', e));
                    }).fail(err=>console.warn('groupInfo fail', err));
                  });
                }
              }
            } catch(e){ console.warn('hidden lic change err', e); }
          }, { passive:true });
        }
      } catch(e){ console.warn('attachHiddenInputListeners err', e); }
    })();

    // main init
    (function main(){
      let attempts=0;
      function tryAttach(){
        attempts++;
        attachWidgetHandlersIfPresent();
        attachVisibleButtonHandlers();
        collectAddButtons();
        updateButtons();
        if (!G.hasWidget && attempts < 12) setTimeout(tryAttach, 700);
      }
      tryAttach();
      const mo = new MutationObserver(throttle(()=>{ collectAddButtons(); updateButtons(); }, 300));
      mo.observe(document.body, { childList:true, subtree:true });
      let last = JSON.stringify(G.licenseUrls || []);
      setInterval(()=>{ try { const cur = JSON.stringify(G.licenseUrls || []); if (cur !== last) { last = cur; updateLicenseUI(); log('licenseUrls changed ->', JSON.parse(cur)); } } catch(e){} }, 700);
    })();

    // form submit
    window.handleProducerFormSubmit = async function(e){
      if (e && e.preventDefault) e.preventDefault();
      setUploadStatus('Preparando...');
      const full = (document.getElementById('full_name')||{}).value||'';
      const email = (document.getElementById('email')||{}).value||'';
      const npn = (document.getElementById('npn')||{}).value||'';
      if (!full.trim() || !email.trim() || !npn.trim()){ setUploadStatus('Completa los campos obligatorios.', true); return false; }
      if (!G.photoUrl && !(document.getElementById('photo_url')||{}).value){ setUploadStatus('Sube la foto primero.', true); return false; }
      if (G.uploadsInProgress && G.uploadsInProgress>0){ setUploadStatus('Aún se están subiendo archivos. Espera.', true); return false; }
      const payload = { full_name: full.trim(), email: email.trim(), npn: npn.trim(), photo_url: G.photoUrl || (document.getElementById('photo_url')||{}).value || '', license_urls: G.licenseUrls || [], submitted_at: new Date().toISOString(), secret: FORM_SECRET };
      setUploadStatus('Enviando...');
      try {
        const res = await fetch(MAKE_WEBHOOK_URL, { method:'POST', headers:{ 'Content-Type':'application/json' }, body: JSON.stringify(payload) });
        if (!res.ok) throw new Error('HTTP '+res.status);
        setUploadStatus('Enviado correctamente. Gracias.');
        const form = document.getElementById('producer-uploadcare-form'); if (form) form.reset();
        const ph = document.getElementById('photo-preview'); if (ph) ph.innerHTML = '';
        G.photoUrl = null; G.licenseUrls = []; updateLicenseUI(); updateButtons();
      } catch(err){ console.error('Send error', err); setUploadStatus('Error al enviar. Revisa la consola.', true); }
      return false;
    };

    // add-to-cart integration
    (function(){
      let lastSent=0;
      document.addEventListener('click', function(ev){
        const btn = ev.target.closest && ev.target.closest(ADD_TO_CART_SELECTORS);
        if (!btn) return;
        const now = Date.now();
        if (now - lastSent < 2000) return;
        lastSent = now;
        const full = (document.getElementById('full_name')||{}).value||'';
        const email = (document.getElementById('email')||{}).value||'';
        const npn = (document.getElementById('npn')||{}).value||'';
        if (!full.trim() || !email.trim() || !npn.trim() || !(G.photoUrl || (document.getElementById('photo_url')||{}).value)) {
          const s = document.getElementById('upload-status');
          if (s){ s.textContent = 'Completa Nombre, Email, NPN y sube la foto antes de añadir al carrito.'; setTimeout(()=>s.textContent='',4000); }
          if (BLOCK_ADD_TO_CART){ ev.preventDefault(); ev.stopPropagation(); btn.classList && btn.classList.add('uc-shake'); setTimeout(()=>btn.classList && btn.classList.remove('uc-shake'),700); return false; }
        }
        try { if (typeof window.handleProducerFormSubmit === 'function') window.handleProducerFormSubmit({ preventDefault: ()=>{} }); } catch(e){ console.warn('invoke submit err', e); }
      }, true);
    })();

  })(); // end coreImplementation

})(); // end IIFE
